export default "/images/6a6dc50748749f524e823c999bfe9014.png";